import React from "react";
import { Box, Typography, Paper, Button, Divider } from "@mui/material";
import CustomerLayout from "../CustomerLayout";

const GettingStartedGuides = () => {
  return (
    <CustomerLayout>
      <Box sx={{ maxWidth: 980, mx: "auto", py: { xs: 2, md: 4 } }}>
        <Typography
          variant="h4"
          sx={{
            fontWeight: 700,
            letterSpacing: "-0.02em",
            mb: 1,
          }}
        >
          Getting Started
        </Typography>

        <Typography
          sx={{
            color: "text.secondary",
            fontSize: "1rem",
            lineHeight: 1.6,
            mb: 4,
            maxWidth: 820,
          }}
        >
          A quick guide to posting, managing, and tracking loads through the HaggleFreight platform.
        </Typography>

        <Paper
          elevation={0}
          sx={{
            border: "1px solid #e5e7eb",
            borderRadius: 3,
            p: { xs: 3, md: 4 },
            boxShadow: "0 8px 24px rgba(15, 23, 42, 0.06)",
          }}
        >
          <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
            1. Post a Load
          </Typography>
          <Typography color="text.secondary" sx={{ lineHeight: 1.6 }}>
            Enter pickup details, drop-off locations, load information, service requirements, and pricing preferences.
          </Typography>

          <Divider sx={{ my: 3 }} />

          <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
            2. Review Driver / Carrier Activity
          </Typography>
          <Typography color="text.secondary" sx={{ lineHeight: 1.6 }}>
            Drivers and carriers can review eligible loads, negotiate pricing, and coordinate transportation details.
          </Typography>

          <Divider sx={{ my: 3 }} />

          <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
            3. Track Your Load
          </Typography>
          <Typography color="text.secondary" sx={{ mb: 3, lineHeight: 1.6 }}>
            Use Track Load to review current status, estimated arrival, route activity, and load updates.
          </Typography>

          <Button
            variant="contained"
            href="/customer/dashboard"
            sx={{ py: 1.3, px: 4, textTransform: "none", fontWeight: 700 }}
          >
            Go to Dashboard
          </Button>
        </Paper>
      </Box>
    </CustomerLayout>
  );
};

export default GettingStartedGuides;